import Vue from 'vue'
import Vuex from 'vuex'
// axios
import api from '../api/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  // 语言
	  lang: localStorage.getItem('ilang') || 'zh_CN',
	  // InterfaceToken
	  InterfaceToken: 'b204cb87ee3d4411982db78a93f72adc',
	  // Authorization
	  Authorization: localStorage.getItem('Authorization'),
	  // 登录后会员信息
	  member: JSON.parse(localStorage.getItem('member')) || {},
	  // 是否登录
	  isLogin: localStorage.getItem('isLogin'),
	  // 感兴趣产品
	  productTagList: [],
	  // 用户头像
	  avatar: localStorage.getItem('avatar') || require('@/assets/Admin/avatar.png'), // 默认头像
	  // 上传统一 action
	  fileUpload: 'common/file/upload',
	  // 国家
	  countryList: [],
	  //权限
	  permissions: JSON.parse(localStorage.getItem('permissions')||'[]'),
  },
  getters: {
	 
  },
  mutations: {
	  // 更改 state
	  changeState(state, param) {
	      for (let i in param) {
	          state[i] = param[i]
	      };
		  
	  },
	  
	  // 所有公共获取属性
	  getAllCategory(state) {
		  // 感兴趣产品
		  api.get(`common/getDict?dictType=sys_interest_product_tag`)
		  .then(res => {
		  	state.productTagList = res.data;
		  })
		  .catch(err => {});
	  }
  },
  actions: {
  },
  modules: {
  }
})
